import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonViewWillLeave,
} from "@ionic/react";
import Lightning from "assets/icons/Lightning";
import {
  eyeOffOutline,
  eyeOutline,
  informationCircleOutline,
} from "ionicons/icons";
import Privacy from "pages/Account/Privacy";
import Terms from "pages/Account/Terms";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { validateEmail } from "utils/Utils";
import { AuthContext } from "../../contexts/AuthContext";
import "./Register.css";

const RegisterForm = () => {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [viewPassword, setViewPassword] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [checked, setChecked] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const {
    userEmail,
    userPassword,
    handleUserEmail,
    handleUserPassword,
    register,
    errorMessage,
    loading,
    setErrorMessage,
    setSuccessMessage,
    country,
    setCountry,
    signup,
  } = authContext;

  const submit = async () => {
    if (!validateEmail(userEmail)) return setErrorMessage("Invalid email.");
    if (userPassword.length < 8)
      return setErrorMessage("Password must be 8 characters long.");
    if (!checked)
      return setErrorMessage("Please agree to our terms and privacy policy.");
    signup();
  };

  useIonViewWillLeave(() => {
    setSuccessMessage("");
    setErrorMessage("");
  });

  useEffect(() => {
    setDisabled(!country);
  }, [country]);

  useEffect(() => {
    if (
      checked &&
      errorMessage === "Please agree to our terms and privacy policy."
    ) {
      setErrorMessage("");
    }
  }, [checked, errorMessage, setErrorMessage]);

  return (
    <IonPage className={"register-page-root"}>
      <IonContent fullscreen>
        <div className={"parent-container"}>
          <div className={"inner-container"}>
            <IonHeader className={"fixed-header ion-hide-md-up"}>
              <IonToolbar>
                <IonButtons slot="start">
                  <IonButton
                    onClick={() =>
                      history.push("/register", { direction: "root" })
                    }
                    color="dark"
                  >
                    <Lightning height={32} />
                  </IonButton>
                </IonButtons>
                <IonTitle>Create Account</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonHeader collapse="condense" className={"dynamic-header"}>
              <div className={"logo-container ion-hide-md-down"}>
                <Lightning height={32} /> <span>Oshi</span>
              </div>
              <IonToolbar>
                <IonTitle size="large">
                  <span className={"register-title"}>
                    Let's create your account.
                  </span>
                </IonTitle>
              </IonToolbar>
              <div className={"subheader-container"}>
                <span>Signing up for Oshi is fast and free.</span>
                <br />
                <span>No commitments or contracts.</span>
              </div>
            </IonHeader>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                register();
              }}
            >
              <IonList lines="none">
                <IonItem className="bordered">
                  <IonLabel position="floating">Email address</IonLabel>
                  <IonInput
                    name="email"
                    type="email"
                    value={userEmail}
                    onIonChange={(e) => handleUserEmail(e)}
                  />
                </IonItem>
                <IonItem className="bordered">
                  <IonLabel position="floating">Password</IonLabel>
                  <IonInput
                    name="password"
                    type={viewPassword ? "text" : "password"}
                    value={userPassword}
                    onIonChange={(e) => handleUserPassword(e)}
                  />
                  <IonIcon
                    onClick={() => setViewPassword(!viewPassword)}
                    icon={viewPassword ? eyeOutline : eyeOffOutline}
                    slot="end"
                  />
                </IonItem>
                <IonItem className={"bordered"}>
                  <IonLabel position="stacked">Select your country</IonLabel>
                  <IonSelect
                    onIonChange={(e) => setCountry(e.target.value)}
                    value={country}
                  >
                    <IonSelectOption value="United States">
                      United States
                    </IonSelectOption>
                    <IonSelectOption value="El Salvador">
                      El Salvador
                    </IonSelectOption>
                  </IonSelect>
                </IonItem>
                <div className={"terms-container"}>
                  <IonCheckbox
                    slot="start"
                    checked={checked}
                    onIonChange={(e) => setChecked(e.detail.checked)}
                  />
                  <IonLabel className="ion-text-wrap">
                    <p>
                      I agree to Oshi's{" "}
                      <span onClick={() => setShowTerms(true)}>Terms</span> and
                      <span onClick={() => setShowPrivacy(true)}>
                        {" "}
                        Privacy Policy.
                      </span>
                    </p>
                  </IonLabel>
                </div>
                {errorMessage && (
                  <IonItem className={"error-message"}>
                    <IonIcon
                      slot="start"
                      icon={informationCircleOutline}
                      size="small"
                      color="danger"
                    />
                    <IonLabel color="danger">{errorMessage}</IonLabel>
                  </IonItem>
                )}
                <IonButton
                  className={"continue-button"}
                  disabled={disabled || loading}
                  expand="block"
                  onClick={() => submit()}
                >
                  {loading ? <IonSpinner name="crescent" /> : "Create account"}
                </IonButton>
                <IonItem
                  className={"forgot-password"}
                  routerLink={"/login"}
                  detail={false}
                >
                  <IonLabel>Already have an account? Sign in.</IonLabel>
                </IonItem>
              </IonList>
            </form>
          </div>
        </div>
      </IonContent>
      <IonModal
        className={"rounded"}
        isOpen={showPrivacy || showTerms}
        initialBreakpoint={0.5}
        breakpoints={[0, 0.5, 1]}
        onDidDismiss={() => {
          setShowPrivacy(false);
          setShowTerms(false);
        }}
      >
        {showPrivacy ? (
          <Privacy onDismiss={() => setShowPrivacy(false)} />
        ) : (
          showTerms && <Terms onDismiss={() => setShowTerms(false)} />
        )}
      </IonModal>
    </IonPage>
  );
};

export default RegisterForm;
